import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MeetingMain from 'flow/components/meeting/shared/MeetingMain';

const VideoRoutes = () => (
    <Switch>
        <Route path="/" component={MeetingMain} />
    </Switch>
);

export default VideoRoutes;
